// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1SuwK","right":"Footer_right__2_cjb","buttons":"Footer_buttons__3v3yK"};